import fr from 'facet-rest';

export const ClientViewOverride = fr.metaOverride()

  .nameOverride('agentEmail', { ordinal: 1, prompt: 'Planner Email' })
  .nameOverride('clientName', { ordinal: 1, prompt: 'Client Name' });
